import cx from "@hsl/core/utils/cx";

import useExplorerStore from "../../store/store";

interface Props {
    className?: string;
}

const CardModeSelector = ({ className }: Props) => {
    const mode = useExplorerStore((state) => state.cardMode);
    const setMode = useExplorerStore((state) => state.setCardMode);
    const numFunds = useExplorerStore(
        (state) => state.refinedData.funds.length,
    );
    if (numFunds === 0) {
        return null;
    }
    return (
        <div
            className={cx(
                "text-charcoal cursor-default text-sm font-medium",
                className,
            )}
        >
            <button
                onClick={() => setMode("card")}
                className={cx(
                    "cursor-pointer appearance-none border-none bg-transparent transition-colors",
                    mode === "card" && "text-core-blue",
                )}
            >
                Card
            </button>
            {" / "}
            <button
                onClick={() => setMode("list")}
                className={cx(
                    "cursor-pointer appearance-none border-none bg-transparent transition-colors",
                    mode === "list" && "text-core-blue",
                )}
            >
                List
            </button>
        </div>
    );
};

export default CardModeSelector;
